import React from 'react'
import ProfileContainer from '../../../profile/ProfileContainer'
import NavigationTabs from '../NavigationTabs'
import Spinner from '../../../global/Spinner'
import NewOrderCard from './NewOrderCard'
import Button from '../../../global/Button'
import Translation from '../../../global/Translation'
import GoBackButton from '../GoBackButton'
import OrdersHistoryFilter from './OrdersHistoryFilter'
import OrderWalkthrough from '../../../walkthroughs/order/OrderWalkthrough'

class NewOrderHistory extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            filters: null,
            shouldRenderWalkthrough: false
        }
    }

    componentDidMount() {
        this.props.setIsOrderHistoryScreen(true)
    }

    componentWillUnmount() {
        this.props.setIsOrderHistoryScreen(false)
    }

    mapFilters = (filters) => {
        if (filters && (filters.selections || filters.search)) {
            return [
                filters.selections && filters.selections.by_date_filter && filters.selections.by_date_filter.value.startDate,
                filters.selections && filters.selections.by_date_filter && filters.selections.by_date_filter.value.endDate,
                filters.selections && filters.selections.by_date_filter && filters.selections.by_date_filter.value.typeDate,
                filters.selections && filters.selections.status_type_filter && filters.selections.status_type_filter.value,
                filters.selections && filters.selections.shipping_type_filter && filters.selections.shipping_type_filter.value,
                filters.selections && filters.selections.dist_center_filter && filters.selections.dist_center_filter.value,
                filters.search
            ]
        }

        return [null, null, null, null, null, null, null]
    }

    fetchOrders = () => {
        this.props.fetchOrders(
            this.props.type,
            ...this.mapFilters(this.state.filters)
        ).then(() => this.setState({ shouldRenderWalkthrough: true }))
    }

    fetchOrdersPaginate() {
        this.props.fetchOrdersPaginate(
            this.props.type,
            ...this.mapFilters(this.state.filters),
            this.props.currentPage + 1
        )
    }

    render() {
        const { orders, orderStatusMap, isLoading, isIkeaCenter, redirect, currentPage, lastPage, adaptedFormat, getMeasure, replaceDotWithComma, locale } = this.props

        return (
            <React.Fragment>
                <GoBackButton />
                <div className="box-profile row">
                    {/* Sidebar */}
                    <div className="profile-container-box col-12 col-md-4 col-lg-3">
                        <ProfileContainer />
                    </div>

                    <div className="col-12 col-xl-9 p-0">
                        {isLoading && <Spinner isLoading={isLoading} />}
                        <div className="order-histoy-container">
                            <div className="order__history__header">
                                <div className="header__title">
                                    <h1>
                                        <Translation id="orders_history" defaultMessage="Order history" />
                                    </h1>
                                </div>
                                <div className="header__subtitle">
                                    <h4>
                                        <Translation id="show" defaultMessage="Show" />
                                    </h4>
                                </div>
                                <NavigationTabs />
                                <OrdersHistoryFilter onChange={filters => this.setState({filters: filters}, this.fetchOrders)}/>
                            </div>
                            {/* <InfiniteScroll dataLength={orders.length} next={() => currentPage < lastPage && this.fetchOrdersPaginate()} hasMore={true} > */}
                                {orders.length > 0 ? (
                                    orders.map((order, idx) => (
                                        <NewOrderCard
                                            key={idx}
                                            order={order}
                                            fetchOrders={this.fetchOrders}
                                            orderStatusMap={orderStatusMap}
                                            isIkeaCenter={isIkeaCenter}
                                            redirect={redirect}
                                            adaptedFormat={adaptedFormat}
                                            getMeasure={getMeasure}
                                            locale={locale}
                                            replaceDotWithComma={replaceDotWithComma}
                                        />
                                    ))
                                ) : null}

                                {/* Button load more */}
                                <div className="d-flex align-items-center justify-content-center mt-2">
                                    <Button onClick={() => this.fetchOrdersPaginate()} size="medium" inline disabled={currentPage >= lastPage || isLoading}>
                                        {currentPage >= lastPage ? (
                                            <Translation id="no_results" defaultMessage="No results" />
                                        ) : (
                                            <Translation id="load_more" defaultMessage="Load more" />
                                        )}
                                    </Button>
                                </div>
                           {/*  </InfiniteScroll> */}
                        </div>
                    </div>
                </div>
                {/* Order history walkthrough */}
                {this.state.shouldRenderWalkthrough && <OrderWalkthrough /> }
            </React.Fragment>
        )
    }
}

export default NewOrderHistory
